const buildMenuItems = (resource) => {
  // TODO: Build menu items once associated sections exist
  return []
}

export default buildMenuItems
